import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "Periodo", -1)
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "Código de alumno", -1)
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = {
  key: 1,
  class: "row"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "Tipo de matrícula", -1)
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = {
  key: 2,
  class: "row"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "Ciclo", -1)
const _hoisted_19 = { class: "col-sm-6" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "# Créditos", -1)
const _hoisted_22 = { class: "col-sm-6" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = { class: "col-sm-6" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "Especialidad", -1)
const _hoisted_28 = { class: "col-sm-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.t('acrd1')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        "status-icon": "",
        rules: _ctx.rules,
        class: "form form-label-right"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('acrd5')), 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_form_item, {
                prop: "acondition",
                rules: [
                            {
                                required: true,
                                message: 'Este campo es requerido',
                                trigger: ['blur', 'change'],
                            },
                        ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.acondition,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.acondition) = $event)),
                    filterable: "",
                    placeholder: "Seleccione"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCondition, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `lstc-${index}`,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.form.acondition == 'E')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_el_form_item, {
                    prop: "periodo",
                    rules: [
                            {
                                required: true,
                                message: 'Este campo es requerido',
                                trigger: ['blur', 'change'],
                            },
                        ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.periodo,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.periodo) = $event)),
                        filterable: "",
                        placeholder: "Seleccione"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPeriodos, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_form_item, {
                prop: "studentcode",
                rules: [
                            {
                                required: true,
                                message: 'Este campo es requerido',
                                trigger: ['blur', 'change'],
                            },
                        ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.studentcode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.studentcode) = $event)),
                    maxlength: "20"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.listTypeMatricule.length>0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_el_form_item, {
                    prop: "tmatricule",
                    rules: [
                            {
                                required: true,
                                message: 'Este campo es requerido',
                                trigger: ['blur', 'change'],
                            },
                        ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.tmatricule,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.tmatricule) = $event)),
                        filterable: "",
                        placeholder: "Seleccione"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTypeMatricule, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: `lstm-${index}`,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.acondition == 'P')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_el_form_item, {
                    prop: "cycle",
                    rules: [
                            {
                                required: true,
                                message: 'Este campo es requerido',
                                trigger: ['blur', 'change'],
                            },
                        ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.cycle,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.cycle) = $event)),
                        filterable: "",
                        placeholder: "Seleccione"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCycles, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: `lstcc-${index}`,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_el_form_item, {
                prop: "credits",
                rules: [
                            {
                                required: true,
                                message: 'Este campo es requerido',
                                trigger: ['blur', 'change'],
                            },
                        ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.credits,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.credits) = $event)),
                    maxlength: "2"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.t('acrd6')), 1),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_el_form_item, {
                prop: "faculty",
                rules: [
                            {
                                required: true,
                                message: 'Este campo es requerido',
                                trigger: ['blur', 'change'],
                            },
                        ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.faculty,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.faculty) = $event)),
                    maxlength: "50"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_el_form_item, {
                prop: "specialty",
                rules: [
                            {
                                required: true,
                                message: 'Este campo es requerido',
                                trigger: ['blur', 'change'],
                            },
                        ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.specialty,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.specialty) = $event)),
                    maxlength: "50"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ])), [
    [_directive_loading, _ctx.loader]
  ])
}